/* eslint-disable quotes */
const kr = {
  "AuthLoginFindAct": "ID 또는 비밀번호를 잊으셨습니까 ?",
  "AuthLoginSbmBtn": "로그인",
  "AuthFindTitle": "아이디 & 비밀번호 찾기",
  "AuthFindReferId": "ID를 분실한 경우 \n관리자에게 문의하십시오",
  "AuthFindReferPw": "만약 당신이 당신의 비밀번호를 잃어버렸다면,\nID와 이메일을 입력하고 암호 찾기 버튼을 클릭하십시오.",
  "AuthFindChgBtn": "비밀번호 찾기",
  "AuthChgComp": "업체명 변경",

  "HeaderInfo": "내 정보",
  "HeaderBody": "체성분",
  "HeaderRank": "순위",
  "HeaderHealth": "건강 지표",
  "HeaderMission": "미션",
  "HeaderChat": "채팅",
  "HeaderLogout": "로그아웃",
  "MngHeaderDashboard": "대시보드",
  "MngHeaderRank": "순위",
  "MngHeaderMember": "멤버",
  "MngHeaderNoti": "알림",
  "MngHeaderChat": "채팅",
  "HeaderExercise": "운동처방",
  "MngHeaderSetting": "설정",
  "MngHeaderMission": "미션",
  "MngHeaderLogout": "로그아웃",

  "AccountPhd01": "업체명",
  "AccountPhd02": "아이디",
  "AccountPhd03": "비밀번호",
  "AccountPhd04": "비밀번호 확인",
  "AccountPhd05": "등록 된 이메일 주소",
  "MyInfoCrudHeader": "내 정보 수정",
  "MyInfo01": "닉네임",
  "MyInfo02": "이메일",
  "MyInfo03": "성별",
  "MyInfo04": "멤버 타입",
  "MyInfo05": "매니저",
  "MyInfo06": "전화 번호",
  "MyInfo07": "매칭 매니저",
  "MyInfo08": "타입",
  "MyInfo09": "가입 일자",
  "MyInfo10": "최종 측정 일",
  "MyInfo11": "로그인 여부",
  "MyInfo12": "업체 코드",
  "MyInfo13": "업체 명",
  "MyInfo14": "주소",
  "MyInfo15": "우편 번호",
  "MyInfo16": "국가",
  "MyInfo17": "멤버",

  "GraphHeader01": "이 달의 체성분 상태",
  "GraphHeader02": "이 달의 미션 달성률",
  "GraphHeader03": "이 달의 목표 달성률",

  "AnalysisProgressHeader01": "낮음",
  "AnalysisProgressHeader02": "중간",
  "AnalysisProgressHeader03": "높음",
  "AnalysisProgressHeader04": "매우 높음",
  "BodyCompTitle01": "체성분 결과",
  "BodyCompTitle02": "체형 분석",
  "BodyCompTitle03": "신체 타입",
  "BodyCompTitle04": "다이어트 코멘트",
  "BodyCompTitle05": "목표체형",
  "BodyCompHeader01": "분석",
  "BodyCompHeader02": "가이드",
  "BodyCompHeader03": "목표체형",
  "BodyCompHeader04": "트렌드",
  "BodyCompHeader05": "목록",
  "BodyCompHeader06": "결과",
  "BodyCompAnalyText01": "코멘트",
  "BodyCompAnalyText02": "상태",
  "BodyCompAnalyText03": "음식",
  "BodyCompAnalyText04": "운동",
  "GoalTitle01": "현재 값",
  "GoalTitle02": "목표 값",
  "GoalTitle03": "추천 값",

  "Analysis": {
    "tableHeader": {
      "bfp": "체지방률",
      "bfm": "체지방량",
      "smm": "골격근량",
      "bmr": "기초대사량",
      "bmi": "체질량지수",
      "weight": "체중",
      "bwp": "체수분",
      "bodyAge": "신체 나이",
      "bodyType": "신체 타입",
      "bodyScore": "신체 점수",
      "stepScore": "걸을수 점수",
      "bodyFatAndSkeletalMuscleRatio": "체지방량/골격근량 비율",
      "properBfp": "적정 체지방율",
      "protein": "단백질",
      "minerals": "무기질",
      "ECWRatio": "세포외수분비"
    }
  },

  "GuideHeader01": "적정 값",
  "GuideHeader02": "현재 값",
  "DashGuide" : "성별, 나이, 몸무게 데이터의 총 전체수는 3가지 모두 입력되어 있을 때의 총 집계량입니다.",
  "RankGuide" : "• 합산 랭킹: 체성분 점수와 걸음수 점수를 1:1 로 환산하여 산정한 점수로 순위를 나타냅니다. <br />• 체성분 랭킹: 체성분을 측정 후 산정된 체성분 점수로 순위를 나타냅니다. <br />• 걸음수 점수: 사용자 앱에서 연동한 걸음수를 5000 보일 때 70점, 10000 보일 때 100점, <br />20000 보일 때 150점으로 산정한 점수로 순위를 나타냅니다",
  "RankBodyGuide": "체성분 점수는 체지방이 얼마나 적은지, 골격근이 얼마나 많은지를 보여주는 점수입니다.\n체지방율을 낮추고 골격근율을 높이면 높은 점수를 받을 수 있습니다.",
  "RankStepGuide": "걸음수 점수는 이번주 얼마나 걸었는지를 보여주는 점수입니다.\n일요일부터 평균 걸음수를 기준으로 걸음 점수가 환산됩니다.\n5000걸음인 경우 70점, 10000걸음 인경우 100점입니다.",

  "UsrBodyComp": "회원의 체성분 상태",
  "UsrGoalAchieve": "회원의 목표 달성율",
  "UsrBodyCompComment": "설정된 기간 내 회원의 체성분 상태 변화 그래프입니다.",
  "UsrGoalAchieveComment": "설정된 기간 내 회원의 목표 달성율을 표시합니다.",

  "HealthHeader01": "심박",
  "HealthHeader02": "혈압",
  "HealthHeader03": "스트레스",
  "HealthHeader04": "수면",
  "HealthHeader05": "온도",
  "HealthHeader06": "걸음수",
  "HealthHeader07": "야외달리기",
  "HealthHeader08" : "혈압\n(입력)",
  "HealthHeader09" : "혈당\n(입력)",
  "BpmHeader01": "Bpm(분당 심장 박동 수)",
  "BpmHeader02": "SpO2(산소 포화도)",
  "StressHeader01": "스트레스 지수",
  "StepsUnit01": "오늘 걸음수",
  "StepsUnit02": "오늘 걸은 거리",
  "StepsUnit03": "오늘 총 소비 칼로리",
  "StepsUnit04": "1주일간 총 걸은 거리",
  "StepsUnit05": "1주일간 총 소비 칼로리",
  "StepsUnit06": "/10,000",
  "StepsUnit07": "km",
  "StepsUnit08": "Cal",
  "StepsUnit09": "걸음",
  "StepsHeader01": "총 걸음 수",
  "StepsHeader02": "스마트폰",
  "StepsHeader03": "원 스마트 다이어트",
  "TempHeader01": "피부 온도",
  "TempHeader02": "사물 온도",
  "TempListHeader01": "항목",
  "TempListHeader02": "온도",
  "OtherCtg01": "날짜",
  "OtherCtg02": "항목 보기",
  "OtherCtg03": "정보",
  "OtherCtg04": "행위",
  "OtherCtg05": "나머지",
  "OtherCtg06": "성공",
  "OtherCtg07": "전체",
  "OtherCtg08": "측정기기",
  "OtherCtg09": "달성",
  "OtherCtg10": "점",
  "OtherCtg11": "세",
  "OtherCtg12": "평균",
  "MeasurementDatetime": "측정일시",
  "Account": "ID",
  "Nickname": "닉네임",

  "device01": "원 스마트 다이어트",
  "device02": "피트러스 플러스",
  "device03": "피트러스 라이트",
  "device04": "피트러스 매니저",
  "device05": "피트러스 A",
  "Notification": "알림",

  "MngDashTotalAvgText01": "멤버",
  "MngDashTotalAvgText02": "체중",
  "MngDashTotalAvgText03": "체지방량(평균.)",
  "MngDashTotalAvgText04": "골격근량(평균.)",
  "MngDashCountText": "명",
  "MngDashCardHeadText01": "전체 사용자 및 성별",
  "MngDashCardHeadText02": "전체 나이",
  "MngDashCardHeadText03": "전체 몸무게",
  "MngDashCardHeadText04": "체지방량 * 골격근량 산점도",
  "MngDashCardHeadText05": "체성분 상태",
  "MngDashCardHeadText06": "미션 달성률",
  "MngDashCardHeadText07": "목표 달성률",
  "MngDashCardSelect01": "일주일",
  "MngDashCardSelect02": "한 달",
  "MngDashCardSelect03": "세 달",
  "MngDashCardSelect04": "여섯 달",
  "MngDashCardSelect05": "일 년",
  "MngRankHelpText": "체성분 점수 순위는 멤버의 최근 점수를 기준으로 순위가 매겨진다. <br> 또한, 단계는 최근 주의 주당 평균 걸음 수 <br>에 따라 순위가 매겨진다.",
  "MngRankCardHeadText01": "멤버 평균 순위",
  "MngMemberAddInfoTitle": "멤버 추가",
  "MngMemberListTitle": "회원 목록",
  "MngMemberExcelDownload": "회원 데이터 다운로드",
  "MngMemberUnclassified": "미분류",

  "MngMember": {
    "actions": {
      "detail": "상세보기",
      "excel": "측정 기록 다운로드",
      "edit": "수정",
      "resetPw": "비밀번호 초기화",
      "delete": "삭제"
    }
  },

  "MngNoticeInfoTitle": "현재 미션",
  "MngNoticeTitle": "전체 목록 - 공지",
  "MngMissionTitle": "전체 목록 - 미션",
  "MngNoticeCrud01": "전송일자",
  "MngNoticeCrud02": "제목",
  "MngNoticeCrud03": "내용",
  "MngNoticeCrud04": "2번째 카테고리",
  "MngNoticeCrud05": "작성자",
  "MngNoticeCrud06": "마지막 수정일자",
  "MngNoticeCrud07": "마지막 수정자",
  "MngNoticeCrud08": "항목",
  "MngNoticeCrud09": "메세지",
  "MngMyInfoCtg02": "로그인 화면의 기본 영상",
  "MngMyInfoCtg03": "첨부 비디오 파일",
  "MngMyInfoPwChg01": "현재 비밀번호",
  "MngMyInfoPwChg02": "새로운 비밀번호",
  "MngMyInfoPwChg03": "새로운 비밀번호 확인",
  "GenderF": "여자",
  "GenderM": "남자",
  "MemType01": "유저",
  "MemType02": "매니저",
  "MngSctNot1st01": "공지",
  "MngSctNot1st02": "미션",
  "MngSctNot2ndMis01": "식단",
  "MngSctNot2ndMis02": "운동",
  "MngAlertListNoticeDel": "삭제하시겠습니까 ?\n 한번 삭제하면 되돌릴 수 없습니다.",
  "MngAlertResetPW": "비밀번호를 초기화 하시겠습니까 ?",
  "MngAlertListNoticeSend": "선택한 항목을 모든 회원에게 보내시겠습니까?",
  "MngScatterPlot": "전체 회원의 체지방량, 골격근량의 산점도",
  "MngBodyComp": "전체 회원의 체성분 상태",
  "MngGoalAchieve": "전체 회원의 목표 달성율",
  "MngMission": "전체 회원의 미션 달성율",
  "MngScatterPlotComment": "설정된 기간 내 측정한 회원의 체지방량과 골격근량의 분산 그래프입니다.",
  "MngBodyCompComment": "설정된 기간 내 전체 회원의 체성분 상태 변화 그래프입니다.",
  "MngGoalAchieveComment": "설정된 기간 내 전체 회원의 목표 달성율을 표시합니다.",
  "MngMissionComment": "설정된 기간 내 전체 회원의 미션 달성율 그래프입니다.",
  "MngMissionCtg": "미션 수정",
  "MngMissionNewCtg": "미션 주제 생성",
  "MngMissionNewNote": "미션 생성",
  "MngMissionSendTitle": "미션 전송",
  "MngMissionSendViewTitle": "미션 상세내역",
  "MngMissionCtg01": "제목",
  "MngMissionCtg02": "내용",
  "MngMissionCtg03": "주제",
  "MngMissionCtg04": "두번째 항목",
  "MngMissionCtg05": "내용",
  "MngMissionCtg06": "최대 용량은 8MB입니다.",
  "MngMissionRate": "미션 달성률",

  "ChooseMissionCategory": "미션 항목 선택",
  "Recipient": "받는 사람",
  "AllMemberListForManager": "{{name}}의 모든 회원",
  "AllMember": "모든 회원",
  "MissionStatus": "미션 현황",
  "Completed":"완료",
  "Incomplete": "미완료",
  "MemberName": "멤버 이름",
  "MissionCompletion": "미션 현황",
  "Status": "현황",
  "MissionLength": 28,

  "ButtonSave": "저장",
  "ButtonEdit": "수정",
  "ButtonCancel": "취소",
  "ButtonClose": "닫기",
  "ButtonDelete": "삭제",
  "ButtonSend": "전송",
  "ButtonResend": "재전송",
  "ButtonNewCtg": "주제 생성",
  "ButtonNewNote": "미션 생성",
  "ButtonNewDelete": "미션 삭제",
  "ButtonTryAgain": "재설정",
  "ButtonResetPass": "비밀번호 초기화",
  "ButtonChangePass": "비밀번호 변경",
  "ButtonAttachment": "파일 등록하기",
  "ButtonSet": "적용",
  "ButtonDetail": "더 보기",
  "ButtonConfirm": "확인",
  "ButtonSctImg": "사진 선택",

  "ttlEdtProfile": "프로필 수정",
  "ttlAddMember": "사용자 추가",
  "ttlEditMember": "사용자 변경",
  "ttlEditManager": "매니저 변경",
  "ttlAccInfo": "계정 정보",
  "ttlCompInfo": "업체 정보",
  "ttlPwInfo": "비밀번호 정보",
  "ttlChgPw": "비밀번호 변경",
  "ttlCptLogo": "업체 로고 이미지",
  "ttlPmtLogo": "업체 홍보 이미지",
  "ttlUnitSet": "단위 설정",
  "ttlTotal": "전체",
  "ttlBodyComp": "신체점수",
  "ttlActivity": "활동량",
  "ttl": {
    "body": "신체 점수",
    "activity": "걸음 수",
    "calorie": "소모 칼로리",
    "bfp": "체지방",
    "bmi": "BMI",
    "subCategory": {
      "user": "멤버",
      "manager": "매니저(팀)",
    },
    "unit": {
      "body": "점",
      "activity": "걸음",
      "calorie": "cal",
      "bfp": "%",
      "bmi": "kg/m²",
    },
    "rank": {
      "rankAlt": "{{rank}}등 메달 이미지",
      "first": "1",
      "second": "2",
      "third": "3",
    },
    "excel": {
      "fileName": "순위_{{startDt}}_{{endDt}}",

      "column": {
        "rank": "순위",
        "memberSeq": "ID",
        "managerName": "팀명",
        "memberName":	"닉네임",

        "avg": "평균",

        "body": "신체 점수",
        "activity": "걸음 수",
        "calorie": "소모 칼로리",
        "bfp": "체지방",
        "bmi": "BMI",
      },
    },
  },
  "ttlCrtMsn": "미션을 생성해주세요.",
  "ttlChsTp": "주제를 선택해주세요.",
  "ttlDrop": "여기에 이미지를 드롭하거나 클릭하여 업로드",
  "ttlDftPw": "기본 비밀번호",

  "lbProfile": "프로필 사진",
  "lbDistance": "거리",
  "lbTemperature": "온도",
  "lbHeight": "키",
  "lbWeight": "몸무게",
  "lbMsnImg": "미션 사진",
  "lbMsnCtg": "미션 항목",
  "lbCreator": "작성자",

  "SuccessSend": "등록되었습니다.",
  "SuccessEdit": "변경되었습니다.",
  "SuccessDelete": "삭제되었습니다.",
  "SuccessMail": "메일이 전송되었습니다.",
  "SuccessEmail": "이메일 형식이 잘못 되었습니다.",
  "SuccessSubmit": "등록되었습니다.",
  "SuccessSave": "저장되었습니다.",

  "ErrorNonReg": "가입되지 않은 계정입니다.",
  "ErrorBlank": "필수 항목을 모두 기입해주세요.",
  "ErrorBlankTopic": "주제를 입력해주세요.",
  "ErrorBlankNote": "미션을 입력해주세요.",
  "ErrorBlankTitle": "제목을 입력해주세요.",
  "ErrorPwNotMatch": "새로운 비밀번호가 일치하지 않습니다.",
  "ErrorCurrnetPwNotMath": "현재 비밀번호가 일치하지 않습니다.",
  "ErrorCurrnetPw": "기존 비밀번호로 변경하실 수 없습니다.",
  "ErrorCheckComp": "업체명을 확인해주세요.",
  "ErrorCheckId": "아이디 또는 비밀번호를 확인해주세요.",
  "ErrorCheckEmail": "아이디 또는 이메일을 확인해주세요.",
  "ErrorSelectCtg": "전송할 항목을 선택해주세요.",
  "ErrorDeleteCtg": "삭제할 항목을 선택해주세요.",
  "ErrorNoData": "먼저 {{type}} 측정을 해주세요.",
  "ErrorNoDataInput": "먼저 {{type}} 입력을 해주세요.",
  "ErrorNotAuth": "권한을 가지고 있지않습니다.",
  "ErrorIdDuplicate": "이미 사용중인 아이디입니다.",
  "ErrorIdType": "ID는 대*소문자 영문, 숫자, 특수기호(- _ @ .) 중 최소 1가지 이상을 포함하여 6~40자여야 합니다.",
  "ErrorIdForbidden": "5회이상 잘못 입력하셨습니다. 관리자에게 문의하시거나 비밀번호 찾기를 이용해주세요.",
  "ErrorNotChooseRecipient": "받는 사람을 선택해주세요.",

  "ErrorPwType": "비밀번호는 대*소문자 영문, 숫자, 특수기호(!#$%&*+-./:;=?@＼^_`~)를 포함하여 8~20자여야 합니다.",
  "ErrorImgFormat": "지원하지 않는 형식입니다.",
  "ErrorNotImg": "이미지를 선택해주세요.",
  "ErrorNoMission": "수신된 미션이 없습니다.",
  "ErrorNotMeasurementList": "측정 기록이 없습니다.",
  "ErrorMissionDownload": "다운로드 할 미션의 날짜와 주제 & 내용을 선택해주세요.",
  "ErrorMissionEmpty": "선택하신 날짜, 주제 & 내용에 해당하는 미션이 없습니다.",
  "ErrorImgMax5": "사진은 5개까지 업로드하실 수 있습니다.",

  "Start": "시작",
  "Current": "현재",
  "Goal": "목표",
  "All": "전체",

  "GoalSetting": "목표 설정",
  "Somato01": "소마토 체형 이란 ?",
  "Somato02": "체형 숫자의 의미",
  "Somato03": "Somatotype 체형은 조직의 상대적 발달 정도에 따라 \n 외형적 체형이 달라진다는 가정으로 Sheldon이 개발한 체형 분류 방법입니다. \n\n체형 번호는 체형을 이루는 구성 요소를 내배엽, 중배열, 외배엽으로 분류하고 \n ( 삼각 모양의 차트 각 꼭지점 ) 3가지 요소를 9단계로 평가하여 \n 숫자를 3쌍으로 배열한 것입니다.",
  "Somato04": "* 내배엽형 \n 앞자리 숫자, 피하지방이 발달하여 몸의 곡선이 둥글고 가슴보다 배가 더 발달한 체형",
  "Somato05": "* 중배엽형 \n 중간자리 숫자, 근육형으로 운동 근육이 발달한 체형",
  "Somato06": "* 외배엽형 \n 마지막 자리 숫자, 외배열성의 피부조직, 신경 및 감각계통이 잘 발달되었으나 근육이 발달되지 않고 가늘고 약한 체형",
  "MissionSucList": "달성 기록 보기",
  "MissionSuc": "미션 달성 기록",
  "MissionComment": "미션 댓글",

  "Download": "다운로드",
  "DownloadMeasureList": "측정 기록을 다운 받으시겠습니까 ?",
  "DownloadRank": "순위 기록을 다운 받으시겠습니까?",
  "SelectDate": "기간 선택",

  "Topic&Cnt": "주제 & 내용",
  "MissionDte": "미션일자",
  "Name": "이름",
  "FitrusBand": "피트러스 밴드",
  "FitrusPlus": "피트러스 플러스",

  "RunningDte": "러닝날짜",
  "TotalDistance": "총 거리",
  "RunningCnt": "러닝횟수",
  "AvgPace": "평균 페이스",
  "AvgHeartRate": "평균 심박수",
  "HeartRate": "심박수",
  "BloodPressure":"혈압",
  "BloodSugar": "혈당",
  "Calorie": "칼로리",
  "MeasurementTime": "측정일시",
  "MeasurementList": "측정기록{{extra}}",
  "TeamMeasurementList": "팀 측정 기록{{extra}}",
  "TeamStepCountList": "걸음 수",
  "TeamHRVList": "HRV",
  "TeamHRVDetailList": "HRV 상세",
  "Min": "최소",
  "Max": "최대",
  "Highest": "최고",
  "Lowest": "최저",
  "Average": "평균",
  "MaxBP": "최고 혈압",
  "MinBP": "최저 혈압",
  "systolic": "수축기 혈압",
  "diastolic": "이완기 혈압",
  "EmptyStomach": "공복",
  "BeforeEat": "식전",
  "AfterEat": "식후",
  "medicine": "약",
  "NotUse": "사용 안함",
  "NotTake": "복용 안함",
  "Take": "복용함",
  "MyToBe": "나의 목표 체형",
  "Hour": "시간",
  "Minute": "분",

  "SearchByRange": "기간별 조회",
  "BedTime": "잠든 시각",
  "WakeUpTime": "일어난 시각",
  "AwakeCount": "깨어난 횟수",
  "DeepSleepTime": "깊은 수면 시간",
  "ShallowSleepTime": "얕은 수면 시간",
  "TotalSleepTime": "총 수면 시간",
  "AvgSleepTime": "평균 수면 시간",
  "DeepSleep": "깊은 수면",
  "AvgDeepSleep": "평균 깊은 수면",
  "ShallowSleep": "얕은 수면",
  "AvgShallowSleep": "평균 얕은 수면",
  "Insomnia": "각성 시간",
  "AvgInsomnia": "평균 각성 시간",
  "MySleepScore": "개인 수면 점수",
  "AvgGroupSleepScore": "단체 평균 수면 점수",
  "AvgAllMySleepScore": "개인 평균 수면 점수",
  "SleepScoreUnit": "점",
  "AvgShort" : "평균",
  "Activity": "활동량",
  "AM": "오전",
  "PM": "오후",
  "Normal": "보통",

  "MinAgo": " 분 전",
  "HourAgo": " 시간 전",
  "JustBefore": "방금 전",
  "AttachedImage": "첨부 이미지",
  "ReplyTo": "{{name}}님에게 답장",
  "Reply": "답장",
  "Me": "나",
  "KL": "KL",
  "NewMessage": "새 메시지",

  "misc": {
    "select": "선택",
    "cancel": "취소",

    "date": {
      "mon": "월",
      "tue": "화",
      "wed": "수",
      "thu": "목",
      "fri": "금",
      "sat": "토",
      "sun": "일"
    },

    "month": {      
      "1": "1월",
      "2": "2월",
      "3": "3월",
      "4": "4월",
      "5": "5월",
      "6": "6월",
      "7": "7월",
      "8": "8월",
      "9": "9월",
      "10": "10월",
      "11": "11월",
      "12": "12월"
    },

    "excel": {
      "teamName": "팀명",
      "date": "일자",
      "stepCount": "걸음수",
      "abdomen": "복부둘레",
      "obesity": "비만도",
      "recommendedDailyCalorieIntake": "권장 칼로리 섭취량",

      "memos": {
        "recommendedDailyCalorieIntake": "현재 체중 유지",
      },

      "rangeDesc": "엑셀 다운로드 기간 선택",

      hrv: 'HRV',
      measureSource: {
        index: '측정 경로',
        hr: '심박',
        stress: '스트레스',
        band: 'Fitrus 밴드',
        stress2: 'HRV',
      },

      fatigueIndex: '피로 지수',
      healthIndex: '건강 지수',
      sri: '스트레스 저항 지수',
      spo2: 'SpO₂',
      hr: 'HR',
      lfPower: 'LF Power',
      hfPower: 'HF Power',
      lfHfRatio: 'LF/HF Ratio',
      sdnn: 'SDNN',
      rmssd: 'RMSSD',
      pnn50: 'pNN50',
      sd1: 'SD1',
      sd2: 'SD2',
    },

    "profileAlt": "{{user}}의 프로필 사진",
  }
}

export default kr